// extracted by mini-css-extract-plugin
module.exports = {"notification":"create-review_notification__rhQXX","additionalBlock":"create-review_additionalBlock__SKw_9"};